const api =
  process.env.NODE_ENV === "production"
    ? "https://cm-api.progress-ims.com/api"
    //"https://progress-claims-api.azersigorta.az/api"
    : "https://localhost:44328/api";
const smsapi = "https://smsapi.huestimates.net/SendSms";
// const smsapi = "https://progress-messages.azersigorta.az/Send/Message/";
const login = "https://login-ui.progress-ims.com/signIn";

const fileurl = process.env.NODE_ENV === "production" 
  ? "https://claimstorages3-progress.s3.eu-north-1.amazonaws.com/Claims/"
  : "https://claimstorages3-progress.s3.eu-north-1.amazonaws.com/Claims/";

const trackerUrl = process.env.NODE_ENV === "production"
  ? "https://claims-online.progress-ims.com/"
  : "http://localhost:8080/";

const subrogationapi = process.env.NODE_ENV === "production"
  ? "https://claims-online.progress-ims.com/"
  : "https://localhost:44328/api";


const carepApi = "https://api.hucarep.com/v1/controller"


function ShowLink(value) {
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function Round2(num) {
  return Math.round(num * 100) / 100;
}

function DaysBetween(dt1, dt2) {
  var oneday = 1000 * 60 * 60 * 24;
  dt1 = new Date(dt1);
  dt2 = new Date(dt2);
  var diff = Math.round(dt2.getTime() - dt1.getTime()) / oneday;

  var res = diff.toFixed(0);
  return res;
}

function DateToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  return year + "-" + month + "-" + date;
}

function DateTimeToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + seconds
  );
}

function DateTimeReverseToString(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");
  return (
    date + "-" + month + "-" + year + " " + hour + ":" + minutes + ":" + seconds
  );
}


function DateTimeReverseToString1(dt) {

  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    month + "-" + date + "-" + year + " " + hour + ":" + minutes + ":" + seconds
  );
}

function DateTimeToJson(dt) {
  dt = new Date(dt);
  let date = ("0" + dt.getDate()).slice(-2);

  let month = ("0" + (dt.getMonth() + 1)).slice(-2);

  let year = dt.getFullYear();

  let hour = dt
    .getHours()
    .toString()
    .padStart(2, "0");

  let minutes = dt
    .getMinutes()
    .toString()
    .padStart(2, "0");

  let seconds = dt
    .getSeconds()
    .toString()
    .padStart(2, "0");

  return (
    year + "-" + month + "-" + date + "T" + hour + ":" + minutes + ":" + seconds
  );
}

function DateToString2(date) {
  if (!date) {
    return null;
  }
  return date.toISOString().split('T')[0];  // yyyy-MM-dd formatında döner
}



function AddMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

function AddDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
function MonthName(month) {
  const monthNames = [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr"
  ];
  return monthNames[month];
}

function NumberFormat(val, digits) {
  return val.toLocaleString(
    "ru-RU", // leave undefined to use the visitor's browser
    // locale or a string like 'en-US' to override it.
    { minimumFractionDigits: digits }
  );
}


function formatDateTime(dateString) {
  if (!dateString) return '';

  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}


const standalone = true;
const labelPosition = 'top';
const textRight = 'text-right'
const textLeft = 'text-left'

export {
  ShowLink,
  HtmlNewLine,
  api,
  smsapi,
  fileurl,
  standalone,
  labelPosition,
  Round2,
  DaysBetween,
  DateToString,
  DateTimeToString,
  AddMonths,
  AddDays,
  MonthName,
  NumberFormat,
  DateTimeToJson,
  DateTimeReverseToString,
  DateTimeReverseToString1,
  login,
  trackerUrl,
  carepApi,
  subrogationapi,
  textRight,
  textLeft,
  formatDateTime,
  DateToString2
};
